import { render } from "./mainTable.vue?vue&type=template&id=3726a841"
import script from "./mainTable.vue?vue&type=script&lang=js"
export * from "./mainTable.vue?vue&type=script&lang=js"
script.render = render

export default script